<!-- TEMP DISABLE -->
<!--
<ul class="nav nav-pills">
<li class="nav-item">
  <button
    type="button"
    id="signupSubscriptionToggleMonthly"
    class="nav-link"
    [ngClass]="{ 'active': isMonthly }"
    (click)="toggleMonthly()"
    (keyup)="toggleMonthly()">
    Monthly
  </button>
</li>
<li class="nav-item">
  <button
    type="button"
    id="signupSubscriptionToggleYearly"
    class="nav-link"
    [ngClass]="{ 'active': !isMonthly }"
    (click)="toggleMonthly()"
    (keyup)="toggleMonthly()">
    Yearly
  </button>
</li>
</ul>
-->

<div class="row mt-4">
  @for (subscription of packages; track subscription.id) {
    <div
      class="col-12 col-sm mb-4 sub-package-detail"
      [ngClass]="{ 'push-top': !subscription.is_recommended }">
      @if (subscription.is_active) {
        <div
          class="card subscription-card"
          [ngClass]="{ 'recommended-card': subscription.is_recommended }">
          @if (subscription.is_recommended) {
            <div class="recommended">Recommended</div>
          }
          <div class="card-body">
            <div class="card-text">
              <div class="card-title">{{ subscription?.name }}</div>
              <div class="subscription-card__price">
                R {{ isMonthly ? subscription?.monthly_cost : subscription?.yearly_cost }}&nbsp;
                <span class="cost-frequency"> per {{ isMonthly ? 'month' : 'year' }} </span>
                @if (!isMonthly && subscription.discount) {
                  <span class="discount-badge badge bg-success text-success ms-1">
                    Save {{ subscription.discount }}%
                  </span>
                }
              </div>
              <div class="subscription-card__features">
                <ul>
                  @for (feature of subscription.features; track $index) {
                    <li>{{ feature }}</li>
                  }
                </ul>
              </div>
            </div>
            <div class="d-grid">
              <button
                [id]="'signupSubscriptionSelect' + subscription.name"
                type="button"
                class="btn mt-3"
                [ngClass]="currentPackage?.package === subscription.id ? 'btn-primary' : 'btn-outline-dark'"
                (click)="onSelectPackage(subscription.id)">
                Choose plan
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

<ng-content select="[content]"></ng-content>

<div class="custom-plan">
  <div class="subscription-card card">
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col-12 col-xl-9">
          <div class="card-title">
            Custom plan needed?
            <span class="card-subtitle">Lets talk about customisation</span>
          </div>
        </div>
        <div class="col-12 col-xl-3 text-xl-end">
          <a
            target="_blank"
            routerLink="/help-desk"
            id="subscriptionSales"
            class="btn btn-outline-primary text-dark mt-2 mt-md-0">
            Contact sales <i class="ps-2 iconoir-arrow-right"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
